<template>
  <section class="content">
    <div class="container-fluid">
		<div class="row">
            <div class="col-12">
               <h3 class="card-title">Detail Mutasi Keluar
                / ID Mutasi Keluar = {{ $route.query['barang_keluar_id'] }}</h3>
            </div>  
        </div>
        <div class="row">
            <div class="col-12" style="padding-bottom:10px;">
				<router-link
					  :to="{
						path: '/mutasi_keluar',
						query: { tahun: tahunMutasiKeluar }
					  }"
					>
						<i class="fa fa-arrow-left">&nbsp;Kembali</i>
					</router-link>
				
                    &nbsp;

                <button v-if="canEdit" type="button" class="btn btn-sm btn-primary" @click="newModal">
                    <i class="fa fa-plus-square"></i>
                    Tambah Detail Mutasi Keluar
                </button>
            </div>
        </div>
		
        <div class="row">
          <div class="col-12">        
            <div class="card">           
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <!--th>ID</th-->
                      <th>Rekening</th>
                      <th>Nama Barang</th>
                       <th>Satuan</th>
                      <th>Qty</th>
                      <th style="text-align:right">Harga Satuan</th>
                      <th style="text-align:right">Total Harga</th>
                      <th v-if="canEdit">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                     <tr v-for="detailbarangkeluar in detailbarangkeluars.data" :key="detailbarangkeluar.id">

                      <!--td>{{ruang.id}}</td-->
                      <td>{{detailbarangkeluar.kategori}}</td>
                      <td class="text-capitalize">{{detailbarangkeluar.nama_barang}}</td>
                      <td>{{detailbarangkeluar.nama_satuan}}</td>
                      <td>{{detailbarangkeluar.qty}}</td>
                      <td align="right">{{returnRupiah(detailbarangkeluar.harga)}}</td>
                      <td align="right">{{returnRupiah(detailbarangkeluar.harga * detailbarangkeluar.qty)}}</td>
                      <td v-if="canEdit">

                        <a href="#" @click="editModal(detailbarangkeluar)">
                            <i class="fa fa-edit blue"></i>
                        </a>
                        |
                        <a href="#" @click="deleteData(detailbarangkeluar.id)">
                            <i class="fa fa-trash red"></i>
                        </a>

                      </td>
                    </tr>

                    <tr>
                        <td colspan="5" style="font-weight:bold; text-align:center;">Grand Total</td>
                        <td style="font-weight:bold; text-align:right;">{{returnRupiah(grandtotal)}}</td>
                        <td v-if="canEdit"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                  <pagination :data="detailbarangkeluars" @pagination-change-page="getResults"></pagination>
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>


        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode">Tambah Detail Mutasi Keluar</h5>
                    <h5 class="modal-title" v-show="editmode">Ubah Detail Mutasi Keluar</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <!-- <form @submit.prevent="createUser"> -->

                <form @submit.prevent="editmode ? updateDetailBarangKeluar() : createDetailBarangKeluar()">
                    
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Nama Barang</label>
                            <v-select :options="barangs" :get-option-label="getLabel" :reduce="(barang) => barang.barang_id"
                                        label="nama_barang"
                                        v-model="form.barang_id"
                                        @option:selected="setSelected"
                            >
                                <template #option="{ nama_barang, satuan, keterangan, stok, barang_id }">
                                    {{ nama_barang }} | Stok {{ stok }} {{ satuan }} | {{ keterangan }}
                                </template>
                            </v-select>
                            <p class="text-danger">Stok : {{stok}} {{satuan}}</p>
                            <has-error :form="form" field="barang_id"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Kategori Barang</label>
                            <v-select :options="kategoris" :reduce="(kategori) => kategori.id"
                                        label="Nama"
                                        v-model="form.kategori_barang_id"
                            ></v-select>
                            <has-error :form="form" field="kategori_barang_id"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Qty</label>
                            <input style="text-align:right;" v-model="form.qty" type="number" id="qty" name="qty"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('Qty') }">
                            <has-error :form="form" field="qty"></has-error>
                        </div>
                         <div class="form-group">
                            <label>Harga Satuan</label>
                            <input style="text-align:right;" @keyup="returnAngkaFloat" @change="getTotalHarga" v-model="form.harga" type="text" id="harga" name="harga"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('Harga') }">
                            <has-error :form="form" field="harga"></has-error>
                        </div>

                        <div class="form-group">
                            <label>Total Harga</label>
                            <input style="text-align:right; font-weight:bold;" id="total_harga" type="text" name="total_harga" value="0" class="form-control" readonly>
                        </div>
                    </div>

                     <input type="hidden" v-model="form.barang_keluar_id" name="barang_keluar_id">

                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button v-show="editmode" type="submit" class="btn btn-success">Simpan</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">Simpan</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
import Datepicker from 'vuejs-datepicker'

    var get_barang_keluar_id = "";
    var totalHarga = 0;

    export default {
        components: {
            Datepicker
        },
        data () {
            return {
                editmode: false,
                detailbarangkeluars : {},
                barangs : [],
                barangId :'',
                kategoris : [],
                stok :'',
                satuan : '',
                harga : '',
                grandtotal:0,
                form: new Form({
                    id : '',      
                    barang_keluar_id: '',
                    barang_id: '',
                    kategori_barang_id: '',
                    nama_barang:'',
                    qty:'',
                    nama_satuan:'',
                    harga:'',
                }),
				tahunMutasiKeluar: null,
				barangkeluar: {
				  status_diterima: null
				},
            }
        },
        methods: {
			
			sortRecords (index, tableName) {				
				this.sortIndex = index
				  this.showTable = tableName

				  this.sortDirection =
					this.sortDirection === 'asc' ? 'desc' : 'asc'

				  this.page = 1
				  this.getResults(1)
            },    
            changePageRange(){
				  this.page = 1
				this.getResults(1)
            },
			
            returnAngkaFloat(e) {
                if (!/^[0-9\.]+$/.test(e.target.value)) {
                        if(e.target.value.substring(e.target.value.length-1) == ','){
                            e.target.value = e.target.value.substring(0,e.target.value.length-1) + ".";
                        }else{
                            e.target.value = e.target.value.substring(0,e.target.value.length-1);
                        }
                }
            },
/*
            returnRupiah(val){
                var number_string = val.toString(),
                    split	= number_string.split('.'),
                    sisa 	= split[0].length % 3,
                    rupiah 	= split[0].substr(0, sisa),
                    ribuan 	= split[0].substr(sisa).match(/\d{1,3}/gi);
                    
                if (ribuan) {
                    var separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }
                
                rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                if(parseFloat(rupiah) == 0){
                    val = 0;
                }else{
                    val = rupiah;
                }
                
                return val;
            },*/
			returnRupiah(val){
				if(val === null || val === '' || val === undefined)
					return '0,00';

				return Number(val).toLocaleString('id-ID',{
					minimumFractionDigits:2,
					maximumFractionDigits:2
				});
			},

            getTotalHarga(){
                var txtQty = 0;
                var txtHargaSatuan = 0;

                txtQty = parseFloat($("#qty").val());
                txtHargaSatuan = parseFloat($("#harga").val());

                if(txtQty > 0 && txtHargaSatuan > 0){
                    totalHarga  = txtQty * txtHargaSatuan;
                }else{
                    totalHarga = 0;
                }

                $("#total_harga").val(returnRupiah(totalHarga));
            },
            getLabel: function(val){
                if(typeof val === 'object'){
                    return val.nama_barang+" | Stok "+val.stok+" "+val.satuan+" | "+val.keterangan;
                }
            },         
            setSelected: function(val) {
                this.stok=val.stok;
                this.satuan=val.satuan;           
            },
            getResults(page = 1) {

                  this.$Progress.start();
                  
                  /*axios.get('/api/detail_mutasi_keluar?barang_keluar_id='+this.get_barang_keluar_id+'&page=' + page).then(({ data }) => (this.detailbarangkeluars = data.data.detail_barang_keluar, this.grandtotal = data.data.grand_total));*/
				  
				  axios.get('/api/detail_mutasi_keluar', {
					params: {
					  barang_keluar_id: this.get_barang_keluar_id,
					  page
					}
				  }).then(({ data }) => {
					this.detailbarangkeluars = data.data.detail_barang_keluar
					this.grandtotal = data.data.grand_total
					this.barangkeluar = data.data.barang_keluar
				  })

                  this.$Progress.finish();
            },
            updateDetailBarangKeluar(){
                this.$Progress.start();
                this.form.put('/api/detail_mutasi_keluar/'+this.form.id)
                .then((response) => {
                    // success
                    $('#addNew').modal('hide');
                    Toast.fire({
                      icon: 'success',
                      title: response.data.message
                    });
                    this.$Progress.finish();
                        //  Fire.$emit('AfterCreate');

                    this.loadDetailBarangKeluars();
                })
                .catch(() => {
                    this.$Progress.fail();
                });

            },

            deleteData(id){
              Swal.fire({
                  title: 'Apa anda yakin?',
                  text: "Setelah terhapus data tidak bisa dikembalikan!",
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  confirmButtonText: 'Ya'
                  }).then((result) => {

                      // Send request to the server
                        if (result.value) {
                            this.form.delete('/api/detail_mutasi_keluar/'+id)
                            .then((response)=>{
                                
                                Toast.fire({
                                        icon: 'success',
                                        title: response.data.message
                                });

                                this.$Progress.finish();

                            })
                            .catch(()=>{
                                Toast.fire({
                                    icon: 'error',
                                    title: 'Some error occured! Please try again'
                                });
                            })

                            window.location.reload();
                        }
                  })
             },
            dataReset(){
                this.stok='';
                this.satuan='';
                this.harga='';
            },
            editModal(detail_barang_keluar){
                this.editmode = true;
                this.form.reset();
                this.dataReset();
                $('#addNew').modal('show');
                this.form.fill(detail_barang_keluar);

                 $("#total_harga").val(returnRupiah(parseFloat(this.form.qty) * parseFloat(this.form.harga)));
            },
            newModal(){
                this.editmode = false;
                this.form.reset();
                //this.dataReset();
                this.form.barang_keluar_id = this.get_barang_keluar_id;
                $('#addNew').modal('show');

                 $("#total_harga").val('0');
            },
            loadKategoris(){
                axios.get("/api/kategori_barang/objlist").then(({ data }) => (this.kategoris = data.data));
            },
            loadBarangs(){
                //let param = _.isEmpty(this.searchTerm) ? 'all' : this.searchTerm;
                axios.get("/api/barang/stok",{ params: { barang_keluar_id: this.get_barang_keluar_id } }).then(({ data }) => (this.barangs = data.data));
            },

            loadDetailBarangKeluars(){
              
                    axios.get("/api/detail_mutasi_keluar?barang_keluar_id="+this.get_barang_keluar_id).then(({ data }) => (this.detailbarangkeluars = data.data.detail_barang_keluar, this.grandtotal = data.data.grand_total));
            },
            
            createDetailBarangKeluar(){
                if(parseFloat(this.form.qty) > parseFloat(this.stok)){
                    Toast.fire({
                                    icon: 'error',
                                    title: 'Qty tidak boleh melebihi Stok !'
                                });
                }else{
                    this.form.post('/api/detail_mutasi_keluar')
                    .then((response)=>{
                        $('#addNew').modal('hide');

                        Toast.fire({
                                icon: 'success',
                                title: response.data.message
                        });

                        this.$Progress.finish();
                        this.loadDetailBarangKeluars();
                    })
                    .catch(()=>{
                        Toast.fire({
                            icon: 'error',
                            title: 'Some error occured! Please try again'
                        });
                    })

                    window.location.reload();
                }
            }
        },
        mounted() {
            console.log('Component mounted.')
        },
        created() {
            let urlParams = new URLSearchParams(window.location.search);           
            this.get_barang_keluar_id =  urlParams.get('barang_keluar_id');

            this.$Progress.start();
            //this.loadDetailBarangKeluars();
			this.getResults();
            this.loadBarangs();
            this.loadKategoris();
            this.$Progress.finish();
			
			this.tahunMutasiKeluar = this.$route.query.tahun
				  ? parseInt(this.$route.query.tahun)
				  : new Date().getFullYear()
        },
		computed: {
		  canEdit() {
			if (!this.barangkeluar) return false
			return parseInt(this.barangkeluar.status_diterima) !== 1
		  }
		},
		watch: {
            searchTerm: function() {
                this.loadDetailBarangKeluars();
            }
        }
    }

    function returnRupiah(val){
                var number_string = val.toString(),
                    split	= number_string.split(','),
                    sisa 	= split[0].length % 3,
                    rupiah 	= split[0].substr(0, sisa),
                    ribuan 	= split[0].substr(sisa).match(/\d{1,3}/gi);
                    
                if (ribuan) {
                    var separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }
                
                rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                if(parseFloat(rupiah) == 0){
                    val = 0;
                }else{
                    val = rupiah;
                }
                
                return val;
            }

            function angkaFloat(e) {
                if (!/^[0-9\.]+$/.test(e.value)) {
                        if(e.value.substring(e.value.length-1) == ','){
                            e.value = e.value.substring(0,e.value.length-1) + ".";
                        }else{
                            e.value = e.value.substring(0,e.value.length-1);
                        }
                }
            }
</script>